<template>
 
        <div class="py-2 w-[900px] flex items-center justify-between gap-10">
            <div >
                <table class="table ">
                    <tbody>
                        <tr class="bg-gray-200 w-20">
                            <th
                                class="  whitespace-nowrap font-bold text-gray-900 text-left">
                               Score
                            </th>
                            <th
                                class=" px-14 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                                Grade
                            </th>
                            <th
                                class="px-14 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                                Remark
                            </th>
                        </tr>
                        <tr>
                            <th
                                class=" whitespace-nowrap font-bold text-gray-900 text-left">
                                70-100
                            </th>
                            <th
                                class=" px-14  whitespace-nowrap font-bold text-gray-900 text-left">
                                A
                            </th>
                            <th
                                class="px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                               Excellent
                            </th>
                        </tr>
                        <tr class="bg-gray-200">
                            <th
                                class="  whitespace-nowrap font-bold text-gray-900 text-left">
                                60-69
                            </th>
                            <th
                                class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                               B
                            </th>
                            <th
                                class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                                Good
                            </th>
                        </tr>
                        <tr class="bg-gray-200">
                            <th
                                class=" whitespace-nowrap font-bold text-gray-900 text-left">
                               50-59
                            </th>
                            <th
                                class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                               C
                            </th>
                            <th
                                class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                                Average
                            </th>
                        </tr>
                       
                    </tbody>
                </table>
            </div>
            <div>
                <table class="table">
                    <tr class="bg-gray-200">
                        <th
                            class="px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                           40-49
                        </th>
                        <th
                            class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                          D
                        </th>
                        <th
                            class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                            Below Average
                        </th>
                    </tr>
                    <tr class="bg-gray-200">
                        <th
                            class=" px-14  whitespace-nowrap font-bold text-gray-900 text-left">
                           0-39
                        </th>
                        <th
                            class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                          E
                        </th>
                        <th
                            class=" px-14 whitespace-nowrap font-bold text-gray-900 text-left">
                            Poor
                        </th>
                    </tr>
                </table>
            </div>
           
        </div>
</template>

<script setup lang="ts">

</script>

